import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  tr: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
  table: {
    fontFamily: ["Poppins", "sans-serif"].join(","),
  },
});

export default theme;
